import { render, staticRenderFns } from "./addcommodity.vue?vue&type=template&id=427811bb&scoped=true"
import script from "./addcommodity.vue?vue&type=script&lang=js"
export * from "./addcommodity.vue?vue&type=script&lang=js"
import style0 from "./addcommodity.vue?vue&type=style&index=0&id=427811bb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "427811bb",
  null
  
)

export default component.exports